__turbopack_context__.v({
  "body-1-bold": "Typography-module-scss-module__o4zIdW__body-1-bold",
  "body-1-regular": "Typography-module-scss-module__o4zIdW__body-1-regular",
  "body-2-bold": "Typography-module-scss-module__o4zIdW__body-2-bold",
  "body-2-regular": "Typography-module-scss-module__o4zIdW__body-2-regular",
  "caption-bold": "Typography-module-scss-module__o4zIdW__caption-bold",
  "caption-regular": "Typography-module-scss-module__o4zIdW__caption-regular",
  "expressive-h1": "Typography-module-scss-module__o4zIdW__expressive-h1",
  "expressive-h2": "Typography-module-scss-module__o4zIdW__expressive-h2",
  "expressive-h3": "Typography-module-scss-module__o4zIdW__expressive-h3",
  "headline-h1": "Typography-module-scss-module__o4zIdW__headline-h1",
  "headline-h2": "Typography-module-scss-module__o4zIdW__headline-h2",
  "headline-h3": "Typography-module-scss-module__o4zIdW__headline-h3",
  "headline-h4": "Typography-module-scss-module__o4zIdW__headline-h4",
  "label-1-regular": "Typography-module-scss-module__o4zIdW__label-1-regular",
  "label-1-semibold": "Typography-module-scss-module__o4zIdW__label-1-semibold",
  "label-2-regular": "Typography-module-scss-module__o4zIdW__label-2-regular",
  "label-2-semibold": "Typography-module-scss-module__o4zIdW__label-2-semibold",
  "micro-bold": "Typography-module-scss-module__o4zIdW__micro-bold",
  "micro-regular": "Typography-module-scss-module__o4zIdW__micro-regular",
  "text-editor-body": "Typography-module-scss-module__o4zIdW__text-editor-body",
  "text-editor-h1": "Typography-module-scss-module__o4zIdW__text-editor-h1",
  "text-editor-h2": "Typography-module-scss-module__o4zIdW__text-editor-h2",
  "text-editor-h3": "Typography-module-scss-module__o4zIdW__text-editor-h3",
  "text-editor-h4": "Typography-module-scss-module__o4zIdW__text-editor-h4",
  "text-editor-h5": "Typography-module-scss-module__o4zIdW__text-editor-h5",
  "text-editor-title": "Typography-module-scss-module__o4zIdW__text-editor-title",
  "typography": "Typography-module-scss-module__o4zIdW__typography",
});
